import AccordionTextBlock from "@/components/AccordionTextBlock/AccordionTextBlock";
import { ContentBlock } from "@/components/ContentBlock/ContentBlock";
import type { FundDetailLayoutComponentProps } from "@/types/fundDetailLayout";

export const FxSourceRatingInformationPanel = ({ dashboard }: FundDetailLayoutComponentProps) => {
	const { fxSourceRatingInformationPanel: props } = dashboard;
	if (!props) {
		return null;
	}

	return (
		<ContentBlock id="fxSourceRatingInformationPanel" data-testid="FxSourceRatingInformationPanel" tabIndex={-1}>
			<AccordionTextBlock {...props} />
		</ContentBlock>
	);
};
